import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { MicrobiologyGridRowItem } from './microbiology-grid-row-item';

@Component({
    selector: 'microbiology-result-cell',
    template: require('./microbiology-result-ag-renderer.component.html'),
    styles: [require('../test-result-ag-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MicrobiologyResultAgRendererComponent implements AgRendererComponent {

    public result = '';
    public isCancelled = false;
    public cancellationReason: string;

    public agInit(row: MicrobiologyGridRowItem): void {
        if (row.node.group) {
            return;
        }

        this.result = row.value;
        this.isCancelled = row.data.isCancelled;
        this.cancellationReason = row.data.cancellationReason;
    }

    public refresh() {
        return false;
    }
}